export const SETTINGS_SET = 'SETTINGS_SET';



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-settings/store/action-types.js